import {
	Component, OnInit, OnDestroy, ViewChild, ViewChildren, QueryList,
	AfterViewInit
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { IdentityService } from '../../services/identity.service';
import { NavigationService } from 'netview';
import { UserListComponent, UsersService, GroupListComponent } from 'identity';
import { AccountType } from '../../../UvExplorerServer.Dtos.TS';
import { AuthSettingsComponent } from '../auth-settings/auth-settings.component';


@Component({
    selector: 'account',
	templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit, OnDestroy {

	public activeIndex: number;
	//public activeIndexChange: EventEmitter<number>;

	constructor(private identityService: IdentityService,
		private usersService: UsersService,
		private navService: NavigationService) {

		this.activeIndex = 0;
		//this.activeIndexChange = new EventEmitter<number>();
	}

	public ngOnInit(): void {

	}

	public ngAfterViewInit(): void {

	}

	private setSelectedTab(tabIndex: number): void {
		//this.tabview.activeIndex = tabIndex;
		this.activeIndex = tabIndex;
	}

	public ngOnDestroy(): void {

	}

	public get isLoggedIn(): boolean {
		return this.identityService.isLoggedIn;
	}

}
